import React from 'react'

import AIListItemLabel from './AIListItemLabel'

import { useAI } from '../hooks'

import styles from './AIListItem.module.css'

const AIListItem = ({ layerId, id }) => {
  const [ai, { select }] = useAI(layerId, id)

  if (ai === null) return null

  return (
    <div
      className={ai.isSelected ? styles.aiSelected : styles.ai}
      onClick={!ai.isSelected && select}
    >
      <AIListItemLabel ai={ai} />
    </div>
  )
}

export default AIListItem
